import type { ComponentType } from 'react';
import { useEffect } from 'react';

import type { FlagsStateContainer } from '@confluence/flags/entry-points/FlagsStateContainer.ts';
import { withFlags } from '@confluence/flags/entry-points/withFlags.ts';

import { useSetBulkCreateFlagsContainer } from '../../providers/AiBulkNavigationContextProvider.tsx';

type BulkCreateFlagsContainerProps = {
	flags: FlagsStateContainer;
};

const BulkCreateFlagsContainerComponent = ({ flags }: BulkCreateFlagsContainerProps) => {
	const setFlags = useSetBulkCreateFlagsContainer();

	useEffect(() => {
		setFlags(flags);
	}, [flags, setFlags]);

	return null;
};

export const BulkCreateFlagsContainer: ComponentType<Omit<unknown, 'flags'>> = withFlags(
	BulkCreateFlagsContainerComponent,
);
